import {
  getCurrentUser,
  fetchAuthSession,
  confirmSignIn,
  resetPassword,
  confirmResetPassword,
  signIn,
  signOut,
} from 'aws-amplify/auth'

import { SpinnerUtils } from '@azimut-mfe/styleguide'

export async function currentAuthenticatedUser(forceRefresh) {
  SpinnerUtils.show()
  if (!forceRefresh) {
    return await getCurrentUser().finally(() => SpinnerUtils.hide())
  } else {
    return await getCurrentUser({
      forceRefresh: true,
    }).finally(() => SpinnerUtils.hide())
  }
}

export async function handleSignIn(username, password) {
  SpinnerUtils.show()
  const { nextStep, isSignedIn } = await signIn({ username, password }).finally(
    () => SpinnerUtils.hide()
  )
  if (isSignedIn) {
    const { tokens } = await fetchAuthSession()
    return tokens
  }

  return nextStep
}

export async function handleConfirmSignIn(newPassword, form) {
  SpinnerUtils.show()
  const { nextStep, isSignedIn } = await confirmSignIn({
    challengeResponse: newPassword,
    options: {
      userAttributes: {
        name: form.name,
      },
    },
  }).finally(() => SpinnerUtils.hide())

  if (isSignedIn) {
    const { tokens } = await fetchAuthSession()
    return tokens
  }

  return nextStep
}

export async function handleResetPassword(username) {
  SpinnerUtils.show()
  return await resetPassword({ username }).finally(() => SpinnerUtils.hide())
}

export async function handleConfirmResetPassword(
  username,
  confirmationCode,
  newPassword
) {
  SpinnerUtils.show()
  return await confirmResetPassword({
    username,
    confirmationCode,
    newPassword,
  }).finally(() => SpinnerUtils.hide())
}

export async function handleSignOut() {
  SpinnerUtils.show()
  return await signOut().finally(() => SpinnerUtils.hide())
}
